export default __webpack_public_path__ + "fonts/dialer-campaign-skip-trace-panel.svg";